module.exports = __webpack_public_path__ + "img/icono-ppt.861b9ba0.svg";